import ProfileAccount from './ProfileAccountContainer';

export default ProfileAccount;
